/*
 *
 * OperationLoyaltyBonusList
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 15-Dec-2025
 */

import React, { useMemo }  from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import MerchantTable from '@nexidigital/merchanttable'
import { formatFiscalAmount } from 'Utility/numberMethods'
import './OperationLoyaltyBonusList.scss'
import formattedMessage, { captions } from './languageModule'


const OperationLoyaltyBonusList = ({selectedOffers, currency, isLoading}) => {
  const intl = useIntl()
  
  const columns = [
    {
      id: 'offerCode',
      label: formattedMessage.offerCode,
      sx: {
        '&.merchantTableCell.MuiTableCell-root > article ': {
          color: 'var(--Color-Text-Neutral-2)',
          fontWeight: 'var(--font-weight-500)'
        }
      }
    },
    
    {
      id: 'redeemedPoints',
      label: formattedMessage.redeemedPoints,
      sx: {
        '&.merchantTableCell.MuiTableCell-root > article ': {
          color: 'var(--Color-Text-Neutral-2)',
          fontWeight: 'var(--font-weight-500)'
        }
      }
    },
    {
      id: 'offerName',
      label: formattedMessage.offerName,
    },
    {
      id: 'redemptionAmount',
      label: formattedMessage.redemptionAmount,
      align: 'right',
      sx: {
        minWidth: '6rem',
        width: '11rem',
        '&.merchantTableCell.MuiTableCell-root > div ': {
          justifyContent: 'flex-start'
        },
        '&.merchantTableCell.MuiTableCell-root > article ': {
          color: 'var(--Color-Text-Neutral-2)',
          fontWeight: 'var(--font-weight-500)'
        }
      }
    }
  ]

 
  const rows = useMemo(
    () =>
      selectedOffers?.map((offer, index) => ({
        id: index,
        offerCode: offer?.offerCode || '-',
        redeemedPoints: offer?.redeemedPoints ? `${offer.redeemedPoints} ${intl.formatMessage(captions.points)}` : '-',
        offerName: offer?.offerName || '-',
        redemptionAmount: offer?.redemptionAmount && currency ? formatFiscalAmount(offer.redemptionAmount, currency) : '-'
      })) || [],
    selectedOffers
  )

  return (
    <div className='operationLoyaltyBonusList'>
      <hr className='separator' />
      <MerchantFlowCard
        id='loyaly_bonus_table'
        title={intl.formatMessage(captions.vouchersListTitle)}>
        <MerchantTable 
          name='loyaltyBonusesTable'
          caption='Loyalty Bonuses' 
          {...{ columns, rows }}
          loading={isLoading}
        />
      </MerchantFlowCard>
    </div>
  )
       
}

OperationLoyaltyBonusList.propTypes = {
  selectedOffers: PropTypes.array,
  currency: PropTypes.string,
  isLoading: PropTypes.bool

}

OperationLoyaltyBonusList.defaultProps = {
  selectedOffers: [],
  currency: null,
  isLoading: false
}

export default OperationLoyaltyBonusList
